module.exports = __webpack_public_path__ + "static/media/paytmSheild.2eb7cd55_UI.svg";